import React, { Component } from 'react';
import { ufaGateBeforeLaunch } from './wallettransfer'; // [2026-10-29] เข้าเกมกระดาน UFA: เช็คกระเป๋า UFA ก่อน
import instance from "./axios-instance";
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import Systems from "./SystemFunction";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categorylist: [],
            userid: props.userid,
            username: props.userid,
            loginstate: props.loginstate,
        };
    }

    // ✅ Navigation handler (เหมือน useCallback เดิม)
    handleNav(to, e = { preventDefault: () => { } }) {
        // ถ้า e ถูกส่งมาจาก onClick ปกติ
        if (e?.preventDefault) e.preventDefault();

        // รองรับ ctrl / alt / middle click
        if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

        console.log("📍 Navigate to:", to);

        if (typeof this.props.onNavigate === "function") {
            this.props.onNavigate(to, e);
        } else {
            // fallback
            window.history.pushState(null, "", to);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    }

    addDefaultSrc(listitem) {
        if (!listitem) return "";
        if (listitem.startsWith("https")) return listitem;
        if (listitem.startsWith("http")) return listitem.replace("http", "https");
        return "https://ardmhzelxcmj.ocrazeckyunc.com" + listitem;
    }
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access

        // Check if point has changed
        if (prevProps.point !== point) {
            if (point !== this.state.point) {
                console.log("componentDidUpdate - point updated:", point);
                this.setState({ point });
            }
        }

        // Check if username has changed
        if (prevProps.userid !== userid) {
            if (userid !== this.state.userid) {
                console.log("componentDidUpdate - username updated:", userid);
                this.setState({ userid: userid });
            }
        }
    }
    // ✅ กดเข้าเกม
    redeem = async (e, gameIdx, partner) => {

        e.preventDefault();
        const userAgent = navigator.userAgent;
        const { loginstate, username } = this.state;

        if (!loginstate) {
            await Swal.fire({
                title: 'Warning!',
                text: 'คุณยังไม่ได้ทำการ Login เราจะย้ายคุณไปสู่หน้า Login',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
            });
            this.handleNav('/signin'); // ✅ ไม่พังแม้ไม่มี event
            return;
        }
        console.log("redeem", gameIdx, partner, username)
        if (!(await ufaGateBeforeLaunch(partner, () => { window.location.href = '/transfer'; }))) return;
        if (username) {
            try {
                const res = await instance.post("/api/v1/tablauncher", {
                    gameId: gameIdx,
                    partner,
                    System: Systems,
                    playerUsername: username,
                    isMobile,
                    demo: false,
                });

                if (res.data.status === 200) {
                    const launcher = res.data.message.launcher;
                    if (!launcher) {
                        Swal.fire({
                            title: 'Error!',
                            text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
                            icon: 'error',
                            confirmButtonText: 'ตกลง',
                        });
                        return;
                    }

                    // ✅ แยกเปิดเกมตามอุปกรณ์
                    if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                        window.location.href = launcher.mobile;
                    } else {
                        if (!isMobile) window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
                        else window.open(launcher.mobile);
                    }
                }
            } catch (err) {
                console.error("tablauncher error:", err);
            }
        }
    };

    async checkonline() {
        const pathname = window.location.pathname.split("/");
        console.log("pathname:", pathname);

        if (pathname.length > 2 && pathname[1] === "listgameall") {
            const typepage = pathname[2].replace("#", "").toLocaleUpperCase();
            const partner = pathname[3].replace("#", "");

            const cacheKey = `tabgamelist_${typepage}_${partner}`;
            const cacheTimeKey = `${cacheKey}_time`;

            const cachedData = localStorage.getItem(cacheKey);
            const cachedTime = localStorage.getItem(cacheTimeKey);
            const isCacheValid =
                cachedData && cachedTime && Date.now() - cachedTime < 30 * 60 * 1000; // 30 นาที

            if (isCacheValid) {
                console.log(`✅ Using cached data for ${cacheKey}`);
                const parsedData = JSON.parse(cachedData);
                this.setState({ typepage, partner, categorylist: parsedData });
                return;
            }

            try {
                const res = await instance.post("/api/v1/tabgamelist", {
                    state: "999",
                    System: Systems,
                    partner,
                    game: typepage,
                });

                if (res.data.status === 200) {
                    console.log(`🆕 Fetching new data for ${cacheKey}`);
                    const categorylist = res.data.message;
                    localStorage.setItem(cacheKey, JSON.stringify(categorylist));
                    localStorage.setItem(cacheTimeKey, Date.now().toString());
                    this.setState({ typepage, partner, categorylist });
                }
            } catch (err) {
                console.error("❌ checkonline error:", err);
            }
        }
    }

    componentDidMount() {
        console.log("TESTcomponentDidMount")
        this.checkonline();
    }

    render() {
        const { categorylist } = this.state;
        console.log("segs", categorylist)
        if (categorylist.length === 0) return null;

        return (
            <>
                <div>
                    <main className="container p-0">
                        <div className="p-1 text-left container-xl text-white mt-1 my5 animated animatedFadeInUp fadeInUp">
                            {/**/}
                            <div className="clearfix">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 className="ps-2 mb-0 f-22 text-title">
                                            <b>สล็อต</b>
                                        </h4>
                                    </div>
                                    <div>
                                        <img role="button" alt="" className="w-icon-cr-bl-record-all" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-1 pb-3 text-white w-scroll-height">
                            <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                <div className="-games-list-container container">
                                    <nav className="nav-menu" id="navbarProvider">
                                        <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                            {categorylist.map((listitem, i) => (
                                                <li className="col-4 col-lg-4 col-md-4 nav-item card-width -random-container -game-sport-macro-container p-1 pb-0 mb-2">
                                                    <a key={i} id={listitem.gameid}
                                                        href={() => false}
                                                        onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)}
                                                    >
                                                        <div
                                                            className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example"
                                                            data-status="-cannot-entry -untestable"
                                                        >
                                                            <div className="-inner-wrapper card-width-banner">
                                                                <div>
                                                                    {/**/}
                                                                    {/**/}
                                                                    {/**/}
                                                                </div>
                                                                <picture>
                                                                    <img
                                                                        role="button"
                                                                        className="w-100 hover-slot hoverTextCss"
                                                                        lazy="loaded"
                                                                        //  data-src={listitem.image}
                                                                        data-src={listitem.image}
                                                                        src={listitem.image}
                                                                    // src={listitem.image}
                                                                    />
                                                                </picture>
                                                                <div className="-overlay d-none d-lg-block">
                                                                    <div className="-overlay-inner">
                                                                        <div className="-wrapper-container">
                                                                            <button href={() => false}
                                                                                className="-btn -btn-play js-account-approve-aware"  >
                                                                                <i className="fas fa-play" />
                                                                                <span className="-text-btn">เข้าเล่น</span>
                                                                            </button>
                                                                            <button
                                                                                id="loginmode"
                                                                                href="#loginModal"
                                                                                className="-btn -btn-play js-account-approve-aware"
                                                                                data-toggle="modal"
                                                                                data-target="#loginModal"
                                                                                style={{ display: "none" }}
                                                                            >
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="-title mt-1 mb-0 text-center text-color-name-game">
                                                                {listitem.description}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>

                                            ))}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </main >
                </div >

            </>

        );

    }
}
export default App;
